import * as types from "./types";

const mutations = {
  [types.SET_AVAIABLE_PRESS](state, payload) {
    // save in store
    state.avaiablePress = payload;
  },
};

export default mutations;
